<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <v-tabs class="mt-4 mb-10">
        <v-tab :to="{ name: 'Users' }">{{ $t("users") }}</v-tab>
        <v-tab class="active">{{ $t("departments") }}</v-tab>
        <v-tab :to="{ name: 'Roles' }">{{ $t("roles") }}</v-tab>
        <v-tab :to="{ name: 'Permissions' }">{{ $t("permissions") }}</v-tab>
      </v-tabs>
      <div class="d-flex mb-4">
        <h2>{{ $t("department") }}</h2>
        <v-spacer></v-spacer>
        <!-- <v-btn color="primary" dark small class="mr-3" :to="{ name: 'Roles' }">
          {{ $t("roles") }}
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn> -->
        <v-btn color="primary" dark small @click="showAddDept = true">
          {{ $t("user.addDepartment") }}
          <!-- <v-icon>mdi-chevron-down</v-icon> -->
        </v-btn>
      </div>
      <!-------------------------- Tablet Screens -------------------------->
      <!-- start -->
      <v-card
        v-if="$vuetify.breakpoint.width <= 980"
        elevation="0"
        class="px-5"
        :loading="loading"
        :class="loading ? '' : 'py-1'"
      >
        <div class="d-flex mt-5">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            outlined
            height="5px"
            :placeholder="$t('user.searchDepartnment')"
            dense
            v-model="search"
            @input="resetSearchOnEmpty"
            class="shrink"
          ></v-text-field>
          <v-btn
            :disabled="search.length < 1"
            color="primary"
            height="40"
            width="40"
            max-width="40"
            outlined
            class="ml-8"
            @click="tabletGetDepartments"
          >
            <v-icon>mdi-filter-outline</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <div class="py-1 title">
            {{ from }} - {{ to }} of {{ totalDepartments }}
          </div>
          <v-btn
            :disabled="tabletTableOptions.page <= 1"
            class="mx-2"
            fab
            small
            outlined
            color="primary"
            @click="tabletPageChange(false)"
          >
            <v-icon dark> mdi-chevron-left </v-icon>
          </v-btn>
          <v-btn
            :disabled="tabletTableOptions.page >= totalPages"
            class="mx-2"
            fab
            small
            outlined
            color="primary"
            @click="tabletPageChange(true)"
          >
            <v-icon dark> mdi-chevron-right </v-icon>
          </v-btn>
        </div>
        <v-card
          v-for="(item, index) in departments"
          :key="item.departmentNumber"
          class="inner-card my-4 py-2 px-4"
          :elevation="0"
          :style="
            index % 2 !== 0 && {
              backgroundColor: 'rgba(243, 243, 243, 0.5)',
            }
          "
          @mouseover="selectItem(item)"
          @mouseleave="selectItem(false)"
        >
          <v-row no-gutters class="my-5">
            <v-col md="6">{{ $t("departmentNum") }}</v-col>
            <v-col md="6">{{ item.departmentNumber }}</v-col>
          </v-row>
          <v-row no-gutters class="my-5">
            <v-col md="6">{{ $t("departmentName") }}</v-col>
            <v-col md="6">{{ item.name }}</v-col>
          </v-row>
          <v-row no-gutters class="my-5">
            <v-col md="6">{{ $t("actionListmod.status") }}</v-col>
            <v-col md="6"
              ><v-btn
                x-small
                rounded
                min-width="120"
                :color="item.status == 1 ? 'green2' : 'red2'"
                depressed
                :class="item.status == 1 ? 'primary--text' : 'red--text'"
                height="34"
              >
                {{ item.status == 1 ? $t("active") : $t("inactive") }}
              </v-btn></v-col
            >
          </v-row>
          <div
            @click="editDepartment(item)"
            style="
              position: absolute;
              right: 15px;
              top: 10px;
              text-decoration: underline;
            "
          >
            <v-btn
              x-small
              fab
              @click="editDepartment(item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              x-small
              fab
              class="ml-2"
              :to="{
                name: 'Roles',
                params: { department: item.departmentNumber },
              }"
            >
              <v-icon>mdi-page-next-outline</v-icon>
            </v-btn>
          </div>
        </v-card>
      </v-card>
      <!------------END -------------------->
      <v-card elevation="1" class="p-5" v-else id="departmentlist">
        <v-card-text>
          <!-- <div class="">
            <template>
              <v-tabs v-model="tab">
                <v-tab :disabled="false">{{ $t("departments") }}</v-tab>
                <v-tab :disabled="true">{{ $t("Deactivated") }}</v-tab>
              </v-tabs>
            </template>
          </div> -->
          <div class="d-flex mt-5">
                  <v-text-field
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    height="5px"
                    :placeholder="$t('user.searchDepartnment')"
                    dense
                    v-model="search"
                    @input="resetSearchOnEmpty"
                    class="shrink"
                  ></v-text-field>
                  <v-btn
                    :disabled="search.length < 1"
                    color="primary"
                    height="40"
                    width="40"
                    max-width="40"
                    outlined
                    class="ml-8"
                    @click="getDepartments"
                  >
                    <v-icon>mdi-filter-outline</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <div class="py-1 title">
                    {{ from }} - {{ to }} of {{ totalDepartments }}
                  </div>
                  <v-btn
                    :disabled="options.page <= 1"
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    @click="pageChange(false)"
                  >
                    <v-icon dark> mdi-chevron-left </v-icon>
                  </v-btn>
                  <v-btn
                    :disabled="options.page >= totalPages"
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    @click="pageChange(true)"
                  >
                    <v-icon dark> mdi-chevron-right </v-icon>
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    @click="exportToPDF"
                  >
                    <v-img src="/icons/download.svg"></v-img>
                    <!-- <v-icon dark> mdi-export </v-icon> -->
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    @click="printPDF"
                  >
                    <v-img src="/icons/print.svg"></v-img>
                    <!-- <v-icon dark> mdi-printer </v-icon> -->
                  </v-btn>
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    left
                    :min-width="417"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        outlined
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark> mdi-cog-outline </v-icon>
                      </v-btn>
                    </template>

                    <v-card width="450">
                      <v-list>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>{{
                              $t("customization")
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <div class="pl-3 pt-2 font-weight-normal">
                          {{ $t("recordsPerPage") }}
                        </div>
                        <v-list-item>
                          <v-list-item-content>
                            <v-slider
                              v-model="itemsPerPageSlider"
                              :tick-labels="itemsPerPageOptions"
                              :max="3"
                              step="1"
                              ticks="always"
                              tick-size="4"
                            ></v-slider>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-n3"></v-divider>
                      </v-list>
                      <v-card-text>
                        <v-container fluid>
                          <v-row>
                            <v-col
                              class="mt-n9"
                              cols="6"
                              v-for="header in headers"
                              :key="header.value"
                            >
                              <v-checkbox
                                v-model="selectedHeaders"
                                :label="header.text"
                                color="primary"
                                :value="header.text"
                                hide-details
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-layout justify-center>
                        <v-card-actions class="mb-5">
                          <v-spacer></v-spacer>

                          <v-btn
                            outlined
                            color="primary"
                            @click="resetDefaultSettings"
                            width="fit-content"
                          >
                            {{ $t("restoreDefault") }}
                          </v-btn>
                          <v-btn
                            color="primary"
                            width="190"
                            @click="resetTableStructure"
                          >
                            {{ $t("apply") }}
                          </v-btn>
                        </v-card-actions>
                      </v-layout>
                    </v-card>
                  </v-menu>
                </div>
          <div ref="document">
            <v-data-table
              :headers="tableHeaders"
              :items="departments"
              :items-per-page="10"
              :footer-props="{
                'items-per-page-options': [10, 25, 50],
              }"
              :header-props="{
                'sort-icon': 'mdi-unfold-more-horizontal'
              }"
              v-model="selected"
              show-select
              :loading="loading"
              :loading-text="$t('loadingData')"
              :options.sync="options"
              :server-items-length="totalDepartments"
              hide-default-footer
            >
              <template v-slot:top="{}">
              
              </template>
              <template v-if="departments.length > 0" v-slot:body="{ items }">
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="item.departmentNumber"
                    style="position: relative; width: 0; height: 0"
                    @mouseover="selectItem(item)"
                    @mouseleave="selectItem(false)"
                  >
                    <td>
                      <v-checkbox
                        multiple
                        v-model="selected"
                        :value="item"
                        style="margin: 0px; padding: 0px"
                        hide-details
                        v-on:click.stop=""
                      />
                    </td>
                    <template>
                      <td v-for="(h, index) in tableHeaders" :key="index">
                        <span
                          v-if="h.value === 'status'"
                          class="d-flex justify-center align-center"
                        >
                          <v-btn
                            x-small
                            rounded
                            min-width="120"
                            :color="item.status == 1 ? 'green2' : 'red2'"
                            depressed
                            :class="
                              item.status == 1 ? 'primary--text' : 'red--text'
                            "
                            height="34"
                            :style="{
                              border:
                                item.status == 1
                                  ? '1px solid green !important'
                                  : '1px solid red !important',
                            }"
                          >
                            {{
                              item.status == 1 ? $t("active") : $t("inactive")
                            }}
                          </v-btn>
                        </span>
                        <span v-else class="text-center">
                          {{ item[h.value] }}
                        </span>
                      </td>
                    </template>

                    <div
                      style="position: absolute; right: 10px; top: 5px"
                    >
                     <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            x-small
                            fab
                            v-bind="attrs"
                            v-on="on"
                            class="green-shadow"
                            @click="editDepartment(item)"
                            :disabled="item.name=='AGROSAVIA'"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t("edit") }}</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            x-small
                            fab
                            v-bind="attrs"
                            v-on="on"
                            class="ml-2 green-shadow"
                            @click="confirmDeptDelete(item)"
                            :disabled="item.name.toLowerCase()=='agrosavia'"
                          >
                            <v-icon>mdi-trash-can-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('geneticsAndBreeding.delete') }}</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            x-small
                            fab
                            v-bind="attrs"
                            v-on="on"
                            class="ml-2 green-shadow"
                            :to="{
                              name: 'Roles',
                              params: { department: item.departmentNumber },
                            }"
                          >
                            <v-icon>mdi-page-next-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('roles') }}</span>
                      </v-tooltip>
                    </div>
                  </tr>
                </tbody>
              </template>
              <!-- <template v-slot:footer></template> -->
            </v-data-table>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
    <add-dept
      v-on:department:added="departmentAdded"
      v-if="showAddDept"
      :dialogI="showAddDept"
      @closeAddDept="showAddDept = false"
    ></add-dept>
    <edit-dept
      v-if="showEditDepartment"
      :department="editedDepartment"
      v-on:department:updated="deptUpdated"
      @closeUpdateDept="editDepartmentClosed"
      :dialogU="showEditDepartment"
    ></edit-dept>
    <confirm-box
      :title="confirmElements.title"
      :message="confirmElements.message"
      :cancelBtnText="confirmElements.cancelBtnText"
      :confirmBtnText="confirmElements.confirmBtnText"
      :confirmData="confirmElements.confirmData"
      :dialog="confirm"
      @confirm:action="confirmDeactivate"
    ></confirm-box>
  </div>
</template>
<script>
import PermissionsService from "@/_services/PermissionsService";
import AddDept from "./AddDepartment.vue";
import EditDept from "./EditDepartment.vue";
import html2pdf from "html2pdf.js";
import printJS from "print-js";
import loadingMixin from "@/mixins/LoadingMixin";
import ConfirmBox from "@/components/ConfirmBox";

export default {
  components: {
    AddDept,
    EditDept,
    ConfirmBox
  },
  watch: {
    options: {
      handler() {
        this.getDepartments();
      },
      deep: true,
    },
    tab: {
      handler() {
        this.getDepartments();
      },
      deep: true,
    },
  },
  created() {
    if (this.checkBreakPoints) this.tabletGetDepartments();
    // const fetchData = async () => {
    // }
    // fetchData()
  },
  updated() {
    // let element = document.getElementById("departmentlist").childNodes[0];
    // this.changeTableSortIcon(element);
  },
  computed: {
    checkBreakPoints() {
      if (this.$vuetify.breakpoint.width <= 980) return true;
      return false;
    },
  },
  data() {
    return {
      confirm: false,
      tab: 0,
      selectedItem: false,
      showEditDepartment: false,
      selected: [],
      editedDepartment: {},
      menu: false,
      itemsPerPageSlider: 1,
      itemsPerPageOptions: [5, 10, 25, 50],
      selectedHeaders: [],
      tableHeaders: [],
      oldSelected: [],
      from: 0,
      to: 0,
      loading: true,
      showAddDept: false,
      search: "",
      totalPages: 1,
      totalDepartments: 0,
      options: {},
      tabletTableOptions: { itemsPerPage: 10, page: 1, sortBy: [] },
      tabs: [
        { name: this.$t("departments"), disable: false },
        { name: this.$t("deactivated"), disable: true },
      ],
      allSelectedHeaders: [
        this.$t("user.departmentNum"),
        this.$t("user.departmentName"),
        this.$t("actionListmod.status"),
        this.$t("action"),
      ],
      noRecordHeader: [
        this.$t("user.departmentNum"),
        this.$t("user.departmentName"),
        this.$t("actionListmod.status"),
        this.$t("action"),
      ],
      headers: [
        {
          text: this.$t("user.departmentNum"),
          align: "start",
          sortable: true,
          value: "departmentNumber",
          class: "secondary2 black--text",
        },
        {
          text: this.$t("user.departmentName"),
          value: "name",
          sortable: true,
          class: "secondary2 black--text",
        },
        // { text: 'Created', value: 'createdAt', class: "secondary2 black--text" },
        {
          text: this.$t("actionListmod.status"),
          align: "center",
          value: "status",
          sortable: false,
          class: "secondary2 black--text",
        },
        {
          text: this.$t("action"),
          align: "center",
          sortable: false,
          class: "black--text",
        },
        // { text: '', align: 'center', value: 'actions', sortable: false, class: "secondary2 black--text" },
      ],
      departments: [],
      breadcrumbs: [
        // {
        //   text: this.$t("dashboard"),
        //   disabled: false,
        //   to: "/",
        // },
        {
          text: this.$t("users"),
          disabled: false,
          to: { name: "Users" },
        },
        {
          text: this.$t("departments"),
          disabled: true,
          href: "breadcrumbs_link_1",
        },
      ],
      confirmElements: {
        title:this.$t('user.deleteDepartment'),
        message: this.$t('user.deleteDepartmentMessage'),
        confirmBtnText: this.$t('geneticsAndBreeding.delete'),
        cancelBtnText: this.$t('cancel'),
        confirmData: {},
      },
    };
  },
  methods: {
    confirmDeptDelete(dept) {
      this.confirmElements.confirmData = { dept: dept };
      this.confirm = true;
    },
    confirmDeactivate(action, confirmData) {
      if (action) {
        this.confirm = false;
        this.deleteDepartment (confirmData.dept);
      }else{
        this.confirm = false;
      }
    },
    async deleteDepartment (dept) {
      this.startLoading()
      try {
        const res = await PermissionsService.deleteDepartment({ departmentNumber: dept.departmentNumber})
        console.log('ress', res)
        this.getDepartments();
        this.stopLoading()
        this.$notify({
            title: this.$t('user.departmentAdded'),
            text: res.msg || 'deleted successfully.',
            type: 'success'
        });
      } catch(e) {
        this.stopLoading()
        this.$notify({
            title: this.$t('user.departmentNotAdded'),
            text: e.msg || 'Unable to delete.',
            type: 'error'
        });
      }

    },
    selectItem(item) {
      this.selectedItem = item;
    },
    // changeTableSortIcon(element) {
    //   let allTh =
    //     element.childNodes[0].childNodes[0].childNodes[1].childNodes[0]
    //       .childNodes[1].childNodes[0].childNodes;
    //   let index = 0;
    //   for (let el of allTh) {
    //     if (index > 0 && el.childNodes[1])
    //       el.childNodes[1].className =
    //         "v-icon notranslate v-data-table-header__icon mdi mdi-unfold-more-horizontal theme--light";
    //     index++;
    //   }
    // },
    resetDefaultSettings() {
      this.menu = false;
      this.tableHeaders = this.headers;
      this.selectedHeaders = this.allSelectedHeaders;
    },
    resetTableStructure() {
      this.tableHeaders = this.headers.filter((header) =>
        this.selectedHeaders.includes(header.text)
      );
      this.options.itemsPerPage =
        this.itemsPerPageOptions[this.itemsPerPageSlider];
      this.menu = false;
    },
    async exportToPDF() {
      html2pdf(this.$refs.document, {
        margin: 1,
        filename: "farmProducts.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    async printPDF() {
      let opt = {
        margin: 1,
        filename: "OrderDetails.pdf",
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
      };
      let worker = await html2pdf()
        .set(opt)
        .from(this.$refs.document)
        .toCanvas()
        .outputPdf("blob", "OrderDetails.pdf");
      let file = new File([worker], "OrderDetails.pdf", {
        type: "application/pdf",
      });
      var pdfUrl = await URL.createObjectURL(file);
      await printJS({ printable: `${pdfUrl}`, type: "pdf", showModal: true });
    },
    getDepartments() {
      this.loading = true;
      PermissionsService.getDepartments(this.options, this.search)
        .then((response) => {
          this.departments = response.data.departments.rows;
          this.totalDepartments = response.data.departments.total_rows;
          if (this.totalDepartments < 1) {
            this.oldSelected = this.selectedHeaders;
            this.selectedHeaders = this.noRecordHeader;
          } else {
            if (this.oldSelected.length > 1)
              this.selectedHeaders = this.oldSelected;
            else {
              this.selectedHeaders = this.allSelectedHeaders;
              this.oldSelected = [];
            }
          }
          this.resetTableStructure();
          this.totalPages = Math.ceil(
            this.totalDepartments / this.options.itemsPerPage
          );
          this.from = (this.options.page - 1) * this.options.itemsPerPage + 1;
          this.to =
            this.options.page * this.options.itemsPerPage -
            (this.options.itemsPerPage - response.data.departments.num_rows);
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    tabletGetDepartments() {
      this.loading = true;
      PermissionsService.getDepartments(this.tabletTableOptions, this.search)
        .then((response) => {
          this.departments = response.data.departments.rows;
          this.totalDepartments = response.data.departments.total_rows;
          this.totalPages = Math.ceil(
            this.totalDepartments / this.tabletTableOptions.itemsPerPage
          );
          this.from =
            (this.tabletTableOptions.page - 1) *
              this.tabletTableOptions.itemsPerPage +
            1;
          this.to =
            this.tabletTableOptions.page *
              this.tabletTableOptions.itemsPerPage -
            (this.tabletTableOptions.itemsPerPage -
              response.data.departments.num_rows);
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    departmentAdded() {
      if (this.checkBreakPoints) this.tabletGetDepartments();
      else this.getDepartments();
      this.showAddDept = false;
    },
    pageChange(t) {
      if (t) this.options.page = this.options.page + 1;
      else this.options.page = this.options.page - 1;

      this.getDepartments();
    },
    tabletPageChange(t) {
      if (t) this.tabletTableOptions.page = this.tabletTableOptions.page + 1;
      else this.tabletTableOptions.page = this.tabletTableOptions.page - 1;
      this.tabletGetDepartments();
    },
    resetSearchOnEmpty() {
      if (this.search === "") {
        this.tabletTableOptions.page = 1;
        this.getDepartments();
      }
    },
    editDepartment(dept) {
      this.editedDepartment = dept;
      this.showEditDepartment = true;
    },
    editDepartmentClosed() {
      this.editedDepartment = {};
      this.showEditDepartment = false;
    },
    deptUpdated(suc) {
      if (suc) {
        if (this.checkBreakPoints) this.tabletGetDepartments();
        else this.getDepartments();
      }
    },
  },
  mixins: [loadingMixin]
};
</script>
<style lang="scss" scoped>
::v-deep .v-tab:hover {
  background-color: #caf1e2;
  color: $primary_color !important;
}

::v-deep .v-data-table-header span {
  // text-transform: uppercase !important;
  color: black;
}

::v-deep .v-data-table__wrapper table tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.035) !important;
}

.active {
  color: $primary_color !important;
  border-bottom: 2px solid $primary_color;
}
::v-deep .v-tabs-slider-wrapper .v-tabs-slider {
  background-color: transparent !important;
}

.v-tab {
  text-transform: none !important;
}

::v-deep .v-data-table-header th {
  white-space: nowrap;
}
::v-deep .v-data-table-header__icon {
  display: inline-block;
  opacity: 100 !important;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
::v-deep .green-shadow:hover {
  background-color: $primary_color;
  color: white;
}
</style>
